import { Component, OnInit } from '@angular/core';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { FeatureFlagsService } from 'src/app/core/shared-service/feature-flags.service';
import { CommonUtil } from '../../../core/Utils/common-util';
import { HaloLoaderService } from '../../../core/halo-loader/halo-loader.service';
import { SoftwareVersionPipe } from '../../pipes/software-version.pipe';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';
import { ScheduleUpdateRemoteUpdatesService } from '../../services/schedule-update-remote-updates.service';
import { SoftwareService } from '../../services/software.service';
import { IRemoteUpdateClassWrapper, assetList, facilityList, updateList } from '../../services/software.service.model';

// this.

@Component({
  selector: 'app-remote-update',
  templateUrl: './remote-update.component.html',
  styleUrls: ['./remote-update.component.scss'],
})
export class RemoteUpdateComponent implements OnInit {
  remoteUpdateData: IRemoteUpdateClassWrapper;
  autoUpdate = true;
  hasSoftware = false;
  filterIsAllUpdate = true;
  formattedLatestSoftwareVersion = '';
  selectAll = false;
  selectedCount = 0;
  confirmationAlertMessage = '';
  confirmationAlertVisible = false;
  attentionAlertVisible = false;
  showScheduleUpdateModal = false;
  assetIDs: string[];
  scheduledhour: number;
  scheduledminute: number;
  scheduledDate: string;
  notConnectedStatusMessage: string;
  pendingAssets: updateList[] = [];
  pendingUpdates: updateList[] = [];
  pendingAssetActivityIds: any[] = [];
  pendingAssetActivityIdsFiltered: any[] = [];
  disableRemoteUpdate = true;

  updateNowPopupData = {
    title: 'CONFIRMATION',
    message: '',
    isWarningPopup: false,
    ctaButtonLabel: 'YES',
    negativeButtonLabel: 'NO',
    isSecondaryTextButton: false,
    hideSecondaryButton: false
  };

  attentionPopupData = {
    title: 'ATTENTION',
    message: 'SWUPDATE.UPDATE.PUSHED',
    isWarningPopup: false,
    ctaButtonLabel: 'OK',
    negativeButtonLabel: 'NO',
    isSecondaryTextButton: false,
    hideSecondaryButton: true
  };

  private selectionInfo: SelectionInfo;

  constructor(
    private softwareService: SoftwareService,
    private loader: HaloLoaderService,
    private toast: HaloToastService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    public commonUtil: CommonUtil,
    private publishScheduleUpdate: ScheduleUpdateRemoteUpdatesService,
    private _featureFlagService: FeatureFlagsService
  ) { }

  ngOnInit(): void {
    // translation
    const _tlink = ` <a target="_blank" href="https://halofitness.zendesk.com/hc/en-us/articles/360060364271-Connect-Equipment-to-Internet">
        ${this.commonUtil.translateText('TROUBLESHOOT')}</a>.`;
    this.notConnectedStatusMessage = this.commonUtil.translateText('EQUIPMENT.NOT.CONNECTED') + _tlink;
    this.disableRemoteUpdate = this._featureFlagService.isOn('disable-remote-update');
  }

  getRemoteUpdateDetails() {
    // load data
    this.loader.startProcess();
    this.softwareService.getRemoteSoftwareUpdates(this.selectionInfo.facility.facilityId, this.selectionInfo.consoleType).subscribe(
      (data: IRemoteUpdateClassWrapper) => {
        this.selectAll = false;
        this.loader.endProcess();
        this.remoteUpdateData = data;
        this.selectedCount = 0;
        this.assetIDs = [];
        this.formattedLatestSoftwareVersion = this.softwareService.getSoftwareVersion(data.latestSoftwareVersion);
        this.setRemoteUpdateValues(
          this.remoteUpdateData.offStatusFacilityList,
          this.remoteUpdateData.onStatusFacilityList
        );
        this.disableGSCTrainer(this.remoteUpdateData.equipmentsList);
        this.getPendingAssets(this.remoteUpdateData.equipmentsList, this.remoteUpdateData.releaseDate);
      },
      (error) => {
        console.error('API failed.');
        this.loader.endProcess();
      }
    );
  }

  setRemoteUpdateValues(offStatusList: facilityList[] | undefined, onStatusList: facilityList[] | undefined): void {
    this.autoUpdate = true;
    if (offStatusList) {
      this.autoUpdate = false;
    }
  }

  disableGSCTrainer(assetSet: assetList[]){
   assetSet.forEach((asset) => asset.activityId.toString() === '18' || this.remoteUpdateData.hasSoftwareRelease === 'false' ? asset.disabled = true: asset.disabled = false);
  }

  getPendingAssets(assetSet: assetList[], softwareReleaseDate: Date): void {
    this.pendingAssets = [];
    this.pendingUpdates = [];
    this.pendingAssetActivityIds = [];
    this.pendingAssetActivityIdsFiltered = [];
    if (assetSet) {
      assetSet.forEach(assetList => {
        if (assetList.softwareUpdateAssetList) {
          assetList.softwareUpdateAssetList.forEach(asset => {
            if (asset.pending == 'true' || this.remoteUpdateData.hasSoftwareRelease === 'false') {
              this.pendingAssets.push(asset);
              this.pendingAssetActivityIds.push(assetList.activityId);
            }
          });
        }
      });
      this.pendingUpdates = this.pendingAssets.filter(
        (asset: updateList) => asset.lastAttemptDate > softwareReleaseDate
      );
    }
    this.pendingAssetActivityIdsFiltered = this.pendingAssetActivityIds.filter((elem, i, arr) => {
      if (arr.indexOf(elem) === i) {
        return elem;
      }
    });
  }

  saveRemoteSoftwareUpdate(isAutoUpdate: boolean): void {
    this.loader.startProcess();
      this.softwareService
        .saveRemoteSoftwareUpdates(this.selectionInfo.facility.facilityId.split(','), this.selectionInfo.consoleType, isAutoUpdate)
        .subscribe(
          (data: null) => {
            this.autoUpdate = isAutoUpdate;
            if (this.remoteUpdateData.offStatusFacilityList) {
              this.remoteUpdateData.onStatusFacilityList = [...this.remoteUpdateData.offStatusFacilityList];
            }
            if (isAutoUpdate) {
              this.toast.creatToast(this.commonUtil.translateText('AUTO.UPDATE.ON'));
            } else {
              this.toast.creatToast(this.commonUtil.translateText('AUTO.UPDATE.OFF'));
            }
            // this._amplitudeAnalytics.logEvent(
            //   'Software - Remote Update - AutoUpdate',
            //   { Console_Type: this.selectionInfo.consoleType, AutoUpdate_Type: + isAutoUpdate.toString() }
            // );
            this.loader.endProcess();
          },
          (error: any) => {
            console.error('API failed.');
            this.loader.endProcess();
          }
        );
  }

  updateNow(): void {
    const selected = this._getSelected();
    const message = this.commonUtil.translateText('SWUPDATE.UPDATE.CONFIRMATION');
    if (selected.ids.length > 0) {
      const uniqueFacilityNames = selected.facilityNames.filter((x: any, i: any, a: any) => a.indexOf(x) == i);
      this.confirmationAlertMessage = `${message} <br/><br/> ${uniqueFacilityNames.join('<br/>')}`;
    }
    this.updateNowPopupData.message = this.confirmationAlertMessage;
    this.confirmationAlertVisible = true;
  }

  updateNowConfirmed(): void {

    const selected = this._getSelected();
    const assetIdList: string[] = [];
    if (selected.ids.length > 0) {
      this.loader.startProcess();
      this.softwareService
        .publishRemoteSoftwareUpdates(selected.ids, this.remoteUpdateData.latestSoftwareVersion, false)
        .subscribe(
          (data: null) => {
            this.confirmationAlertVisible = false;
            this.attentionAlertVisible = true;
            // this._amplitudeAnalytics.logEvent(
            //   'Software - Remote Update - Update',
            //   { Console_Type: this.selectionInfo.consoleType }
            // );
            //this.getRemoteUpdateDetails();
            if (!this.selectAll) {
              this.selectAll = true;
            }
            this.changeSelectAll();
            this.selectedCount = 0;
            this.assetIDs = [];
            this.loader.endProcess();
          },
          (error: any) => {
            console.error('API failed.');
            this.loader.endProcess();
          }
        );
    }

  }
  updateNowCanceled(): void {
    this.confirmationAlertVisible = false;
  }

  showUpdateSuccess(): void {
    const swVersion = new SoftwareVersionPipe().transform(this.remoteUpdateData.latestSoftwareVersion);
    this.attentionAlertVisible = false;
    this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = false;
    this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('UPDATE.SOFTWARE.SUCCESS', [this.selectionInfo.rootScopeData.consoleRights.get(this.selectionInfo.consoleType).consoleName + ' ' + swVersion]));
  }

  closeAttentionModal(): void {
    this.attentionAlertVisible = false;
  }

  scheduleUpdate(): void {
    this.showScheduleUpdateModal = true;
  }

  showAllUpdates(value: boolean) {
    if (this.remoteUpdateData.hasSoftwareRelease === 'true') {
      this.filterIsAllUpdate = value;
    }
  }

  displyHeaderCheck(activityId: string) {
    if (this.filterIsAllUpdate === false && this.pendingAssetActivityIdsFiltered.findIndex(x => x === activityId) == -1) {
      return false;
    } else {
      return true;
    }

  }


  getRowGroupTitle(activityId: string): string {
    let _activityId = '';
    let _shortNames = '';

    switch (parseInt(activityId)) {
      case 1:
        _activityId = 'TREADMILLS';
        _shortNames = 'TREADMILLS';
        break;
      case 2:
        _activityId = 'LIFECYCLE.EXERCISE.BIKES';
        _shortNames = 'LIFECYCLE.EXERCISE.BIKES';
        break;
      case 4:
        _activityId = 'ELLIPTICAL.CROSS.TRAINERS';
        _shortNames = 'EQ.TYPE.4';
        break;
      case 12:
        _activityId = 'SUMMIT.TRAINER';
        _shortNames = 'SUMMIT.TRAINER';
        break;
      case 13:
        _activityId = 'STAIR.CLIMBER';
        _shortNames = 'STAIR.CLIMBER';
        break;
      case 15:
        _activityId = 'FLEXSTRIDER.VARIABLE.STRIDE.TRAINERS';
        _shortNames = 'EQ.TYPE.15';
        break;
      case 16:
        _activityId = 'POWERMILL.CLIMBERS';
        _shortNames = 'EQ.TYPE.16';
        break;
      case 18:
        _activityId = 'GSC.TRAINERS';
        _shortNames = 'GSC.TRAINERS';
        break;
      case 19:
        _activityId = 'EQ.TYPE.19';
        _shortNames = 'EQ.TYPE.19';
        break;
      case 20:
        _activityId = 'EQ.TYPE.20';
        _shortNames = 'EQ.TYPE.20';
        break;
      case 28:
        _activityId = 'PERFORMANCE.TREADMILLS';
        _shortNames = 'PERFORMANCE.TREADMILLS';
        break;
    }

    if (this.selectionInfo.rootScopeData.deviceType !== 'phone') {
      return _activityId;
    } else {
      return _shortNames;
    }
  }

  changeSelectAll(equipmentsListIndex?: number) {
    if (typeof equipmentsListIndex === 'undefined') {
      this.selectAll = !this.selectAll;
      this.remoteUpdateData.equipmentsList.forEach((item) => {
        item.selected = item?.disabled?false:this.selectAll;
        item.softwareUpdateAssetList.forEach((asset: any) => {
          asset.selected = item?.disabled || asset.isLatestSofware == 'true' ? false : this.selectAll;
        });
      });
    } else {
      const selectedType = this.remoteUpdateData.equipmentsList[equipmentsListIndex];
      const _value = selectedType?.disabled?false: !selectedType.selected;
      if(!selectedType?.disabled){
        selectedType.softwareUpdateAssetList.forEach((asset: any) => {
          if (asset.isLatestSofware == 'false') {
            asset.selected = _value;
          }
        });
      }
    }
    this._getSelected();
  }

  selectUpdate(asset: updateList, isDisabled: boolean) {
    if(!isDisabled){
      asset.selected=!asset.selected; 
      this._getSelected();
    }
  }
  onPositiveConfirmation() {
    this.showScheduleUpdateModal = false;
    this.scheduleUpdateoftheSelectedItems();
  }

  closeDisabledModal() {
    this.showScheduleUpdateModal = false;
  }
  private _getSelected(): any {
    this.selectedCount = 0;
    const _ids: string[] = [];
    const _facilityNames: string[] = [];

    let _allSelected = true;
    this.remoteUpdateData.equipmentsList.forEach((item, i) => {
      let _allSelectedInGroup = true;
      item.softwareUpdateAssetList.forEach((asset) => {
        if (asset.selected) {
          _ids.push(asset.assetId);
          _facilityNames.push(asset.facilityName);
          this.selectedCount = this.selectedCount + 1;
          this.setDraftedFlag();
        } else {
          if(!item?.disabled){
            _allSelectedInGroup = false;
            _allSelected = false;
          }
        }
      });
      item.selected = item?.disabled?false : _allSelectedInGroup;
    });
    this.selectAll = _allSelected;
    this.assetIDs = _ids;

    return { ids: _ids, facilityNames: _facilityNames };
  }

  getTimeSchedule(time: string) {
    let timeArray: string[];
    timeArray = time.split(':');
    this.scheduledhour = parseInt(timeArray[0].trim());
    this.scheduledminute = parseInt(timeArray[1].trim());
  }

  getDateSchedule(date: string) {
    this.scheduledDate = date;
  }

  scheduleUpdateoftheSelectedItems() {
    const latestSoftwareVersion = this.formattedLatestSoftwareVersion.split('.').join('');
    const dataToSendForScheduleUpdate = {
      assetIds: this.assetIDs,
      hours: this.scheduledhour,
      isSchedule: true,
      latestSoftwareVersion,
      mins: this.scheduledminute,
      publishDateString: this.scheduledDate
    };

    this.publishScheduleUpdate.publishScheduleUpdate(dataToSendForScheduleUpdate).subscribe(
      data => {
        this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = false;
        const swVersion = new SoftwareVersionPipe().transform(this.remoteUpdateData.latestSoftwareVersion);
        this.toast.creatToast(this.commonUtil.replaceValueAsHTMLOnTranslatedText('SCHEDULE.SOFTWARE.SUCCESS', [this.selectionInfo.rootScopeData.consoleRights.get(this.selectionInfo.consoleType).consoleName + ' ' + swVersion]));
        // this._amplitudeAnalytics.logEvent(
        //   'Software - Remote Update - Scheduled Software Update',
        //   { Console_Type: this.selectionInfo.consoleType }
        // );
        this.getRemoteUpdateDetails();

      }, error => {
      }
    );



  }
  setDraftedFlag(): void {
    (this.selectedCount > 0);
    { this.selectionInfo.rootScopeData.isPageHasUnsavedChanges = true; }
  }

  onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      this.hasSoftware = this.selectionInfo.facility.summary.userRights.software === 'F';
      this.commonUtil.softwareRedirectToFacility('remote-update');
      this.disableRemoteUpdate = this._featureFlagService.isOn('disable-remote-update');
      this.getRemoteUpdateDetails();
    });
  }
}
